export const selectFormattedUser = (userObject) => {
  // Backend responses are not consistent across auth flows:
  // - sign in: { user: {...}, access_token: ... }
  // - some password flows may return the user at the top level: { id, email, ... }
  const user = userObject?.user ?? userObject

  // Fail-safe: avoid crashing the UI if response is malformed.
  if (!user) {
    return {
      id: "",
      fullName: "",
      email: "",
      role: "",
      photo: "",
      uuid: "",
      company: {},
    }
  }

  return {
    id: user.id,
    fullName: user.full_name,
    email: user.email,
    role: user.account_type,
    photo: user.photo,
    uuid: user.uuid,
    company: {
      id: user.company?.id,
      uuid: user.company?.uuid,
      name: user.company?.name,
      type: user.company?.company_type,
      photo: user.company?.photo,
    },
  }
}
